import format from 'date-fns/format';
import { COUNTRIES } from '@/constants/profile';
import { AGE } from '@/constants/account';

export const getDate = (value) => (
  value instanceof Date ? value : value ? new Date(value) : undefined
);

export const formatDate = (date) => {
  const parsedDate = getDate(date);
  return parsedDate?.toISOString()?.split('T')[0] || '';
};

export const dateToStringFormat = (date, dateFormat) => {
  return format(new Date(date), dateFormat);
};

export const getDateDownLimitError = (trad, down = getLimitDown()) => {
  return getDateLimitError(trad, down);
};

export const getDateUpLimitError = (trad, up = new Date()) => {
  return getDateLimitError(trad, up);
};

export const getDateLimitError = (trad, date) => {
  return trad.replace(':dd', date.getDate()).replace(':mm', date.getMonth() + 1).replace(':yyyy', date.getFullYear());
};

export const getLimitDown = () => {
  const now = new Date();
  return new Date(now.setYear(now.getFullYear() - AGE.OLDER_ALLOWED));
};

export const getMajorityLimit = (country) => {
  const now = new Date();
  return new Date(now.setYear(now.getFullYear() - (country === COUNTRIES.USA ? AGE.IS_21 : AGE.IS_18)));
};

export const formatLongLocalDate = (value, locale, options = { weekday: 'long', day: 'numeric', month: 'long' }) => {
  if (!value) {
    return '';
  }

  const parsedDate = new Date(value);
  if (!(parsedDate instanceof Date) || isNaN(parsedDate)) {
    return '';
  }

  return (new Date(value)).toLocaleDateString(locale, options);
};

export const formatSlotToLocaleString = (slot, locale) => {
  if (slot) {
    return {
      day: formatKebabCaseDate(slot[0], locale),
      slot: {
        start: new Date(slot[0]).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' }),
        end: new Date(slot[1]).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
      }
    };
  }
  return {};
};

export const formatKebabCaseDate = (date, locale) => {
  return new Date(date).toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }).replaceAll('/', '.');
};

export const formatLiteralDate = (date, locale) => {
  if (!date) {
    return '';
  }
  if (date?.includes('-')) {
    const splittedDate = date.split('-').reverse().join('.');
    return new Date(splittedDate).toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' });
  }
};
